import { render } from "./EchipeList.vue?vue&type=template&id=5780a783&scoped=true"
import script from "./EchipeList.vue?vue&type=script&lang=js"
export * from "./EchipeList.vue?vue&type=script&lang=js"

import "./EchipeList.vue?vue&type=style&index=0&id=5780a783&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5780a783"]])

export default __exports__